import { message } from "antd";
import { invalidImageDimensionErrorMessage } from "../../../core/utils/constants/constants";

const dimensionValidation = (imageWidth, imageHeight, bulkUpload = false) => {
  if (
    (imageWidth === 300 && imageHeight === 250) ||
    (imageWidth === 320 && imageHeight === 50) ||
    (imageWidth === 728 && imageHeight === 90) ||
    (imageWidth === 160 && imageHeight === 600) ||
    (imageWidth === 300 && imageHeight === 600) ||
    (imageWidth === 300 && imageHeight === 50) ||
    (imageWidth === 970 && imageHeight === 250) ||
    (imageWidth === 320 && imageHeight === 480) ||
    (imageWidth === 336 && imageHeight === 280) ||
    (imageWidth === 320 && imageHeight === 100)
  ) {
    return true;
  } else {
    if (bulkUpload) {
      return false;
    } else {
      message.error(invalidImageDimensionErrorMessage);
      return false;
    }
  }
};

export default dimensionValidation;
